import React from 'react';

import { Box, Button, Typography } from '@material-ui/core';
import { AiOutlineCamera } from 'react-icons/ai';

import { COPY } from '../config';
import useStyles from '../styles';

interface Props {
  isCSCS: boolean;
  onStartCapture: () => void;
  onManual: () => void;
}

export const IntroPhase = ({ isCSCS, onStartCapture, onManual }: Props) => {
  const classes = useStyles();
  const copy = isCSCS ? COPY.cscsIntro : COPY.qualificationIntro;

  return (
    <Box display="flex" flexDirection="column" gridGap={16}>
      <Box>
        <Typography variant="h6">{copy.title}</Typography>
        <Typography variant="body2" color="textSecondary">
          {copy.subtitle}
        </Typography>
      </Box>

      {isCSCS && (
        <Box className={classes.noteBox}>
          <Typography variant="body2" color="textSecondary">
            {COPY.cscsIntro.note}
          </Typography>
        </Box>
      )}

      <Button
        variant="contained"
        color="primary"
        size="large"
        startIcon={<AiOutlineCamera />}
        onClick={onStartCapture}
      >
        {copy.primary}
      </Button>

      <Button color="primary" className={classes.manualLink} onClick={onManual}>
        {COPY.manualLink}
      </Button>
    </Box>
  );
};
